import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export function useReportFastFashion() {
  const qc = useQueryClient();
  const { session } = useAuth();
  const userId = session?.user?.id;

  return useMutation({
    mutationFn: async (params: { scanId: string; reason?: string }) => {
      if (!userId) throw new Error("Sign in required");
      const { error } = await supabase.from("fast_fashion_reports").insert({
        reporter_id: userId,
        scan_id: params.scanId,
        reason: params.reason ?? null,
      });
      if (error) throw error;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["feed"] });
      qc.invalidateQueries({ queryKey: ["scans"] });
    },
  });
}
